import React from 'react';
import { Star, Quote, MapPin, ExternalLink } from 'lucide-react';

const GoogleReviewsWidget = () => {
  // Reviews data - can be updated with actual reviews
  const reviews = [
    {
      name: 'Priya & Rahul Sharma',
      rating: 5,
      date: '2 weeks ago',
      text: 'Absolutely amazing wedding planners! They made our destination wedding in Dharamshala absolutely magical. Every detail was perfect. Highly recommended!',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=75'
    },
    {
      name: 'Ananya & Vikram Malhotra',
      rating: 5,
      date: '1 month ago',
      text: 'Best decision we made was choosing Destination Weddings & Events. The decor was stunning, sound system was top-notch, and the team was incredibly professional.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=75'
    },
    {
      name: 'Meera & Arjun Kapoor',
      rating: 5,
      date: '1 month ago',
      text: 'Our wedding was beyond our dreams! The mountain views, beautiful decor, and seamless coordination made it unforgettable. Thank you team!',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=75'
    },
    {
      name: 'Neha & Rohan Gupta',
      rating: 5,
      date: '2 months ago',
      text: 'From venue selection to the final goodbye, everything was handled with utmost care. Mrs. Rinyy and team are the best in Dharamshala!',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&q=75'
    }
  ];

  const googleMapsUrl = 'https://www.google.com/maps/place/Destination+Weddings+and+Events/@32.1848638,76.3254909,17z';

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FFF8FA]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#E91E8C]/10 rounded-full mb-6">
            <Star className="h-4 w-4 text-[#E91E8C] fill-[#E91E8C]" />
            <span className="text-[#E91E8C] text-sm font-semibold tracking-wider uppercase">Client Reviews</span>
          </div>
          <h2 
            className="text-[#2C2C2C] mb-4"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(32px, 4vw, 48px)',
              fontWeight: 700
            }}
          >
            Loved by 500+ Couples
          </h2>
          
          {/* Google Rating Summary */}
          <div className="inline-flex items-center gap-4 bg-white rounded-2xl px-8 py-4 shadow-lg border border-gray-100 mt-6">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="h-6"
            />
            <div className="h-8 w-px bg-gray-200"></div>
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-[#2C2C2C]">4.9</span>
              <div className="flex">
                {[1,2,3,4,5].map((star) => (
                  <Star key={star} className="h-5 w-5 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-600">Based on</p>
              <p className="text-sm font-semibold text-[#2C2C2C]">200+ Reviews</p>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              {/* Quote Icon */}
              <Quote className="h-8 w-8 text-[#E91E8C]/20 mb-4" />
              
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              
              {/* Review Text */}
              <p className="text-[#555] text-sm leading-relaxed mb-6">
                "{review.text}"
              </p>
              
              {/* Reviewer Info */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <img 
                  src={review.image}
                  alt={review.name}
                  loading="lazy"
                  decoding="async"
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-[#2C2C2C] text-sm">{review.name}</p>
                  <p className="text-xs text-gray-400">{review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white border-2 border-[#E91E8C] text-[#E91E8C] font-semibold rounded-full hover:bg-[#E91E8C] hover:text-white transition-all duration-300"
          >
            <MapPin className="h-5 w-5" />
            See All Reviews on Google
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default React.memo(GoogleReviewsWidget);
